import { render, staticRenderFns } from "./inviteDialog.vue?vue&type=template&id=7bf5efb6&scoped=true"
import script from "./inviteDialog.vue?vue&type=script&lang=js"
export * from "./inviteDialog.vue?vue&type=script&lang=js"
import style0 from "./inviteDialog.vue?vue&type=style&index=0&id=7bf5efb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf5efb6",
  null
  
)

export default component.exports